import React, { useState } from "react";
import './Gallery.css?v=123';

const images = [
  { src: "assets/images/gallery/1.jpg", alt: "Image 01" },
  { src: "assets/images/gallery/2.jpg", alt: "Image 02" },
  { src: "assets/images/gallery/3.jpg", alt: "Image 03" },
  { src: "assets/images/gallery/4.jpg", alt: "Image 04" },
  { src: "assets/images/gallery/5.jpg", alt: "Image 05" },
  { src: "assets/images/gallery/6.jpg", alt: "Image 06" },
  { src: "assets/images/gallery/7.jpg", alt: "Image 07" },
  { src: "assets/images/gallery/8.jpg", alt: "Image 08" },
  { src: "assets/images/gallery/9.jpg", alt: "Image 09" },
  { src: "assets/images/gallery/10.jpg", alt: "Image 10" },
  { src: "assets/images/gallery/13.jpg", alt: "Image 13" },
  { src: "assets/images/gallery/14.jpg", alt: "Image 14" }
];

const Gallery = () => {
  const [lightboxImage, setLightboxImage] = useState("");
  const [lightboxAltImage, setLightboxAltImage] = useState("");

  const openLightbox = (src, alt) => {
    setLightboxImage(src);
    setLightboxAltImage(alt);
  };

  const closeLightbox = () => {
    setLightboxImage("");
    setLightboxAltImage("");
  };

  return (
            <div className="gallery-body">

              <div className="gallery-heading">
              <h1>
              Gallery
              </h1>
              <p>Have a look at some images taken at our institution</p>
              <span class="line-bar">...</span><br />
              </div><br /><br />
        

        <div id="react"></div>

      <div className="gallery">
        {images.map((image, index) => (
          <button
            type="button"
            className="gallery__item"
            key={index}
            onClick={() => openLightbox(image.src, image.alt)}
          >
            <img className="gallery__image" src={image.src} alt={image.alt} />
          </button>
        ))}
      </div>

      {lightboxImage && (
        <div className="lightbox">
          <button
            type="button"
            className="lightbox__close-button"
            onClick={closeLightbox}
          >
            &times;
          </button>
          <img
            className="lightbox__image"
            src={lightboxImage}
            alt={lightboxAltImage}
          />
          <button
            type="button"
            className="lightbox__bg"
            onClick={closeLightbox}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
